import React, { Component } from "react";
import "./Advisary.css";
import ReactPaginate from "react-paginate";
import $, { event } from "jquery";
import OutsideClickHandler from "react-outside-click-handler";
import { Col, Row } from "react-bootstrap";
import { FiThumbsUp } from "react-icons/fi";
import { NotificationManager } from "react-notifications";
import { Container } from "@material-ui/core";

class AdvisaryComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consumeruserparent: "consumer2",
      tenders: [],
      tendersFilter: [],
      offset: 0,
      tensdersPageCount: 1,
      perPage: 3,
      currentPage: 0,
      checked: false,
      postCategoryIdVlaue: "",
      InitialAccessToken: localStorage.getItem("GlobalAccess"),
      subCategoriesList: [],
      copyOfTenders: [],
      contentOwners:[]
      
    };
    this.handlePageClick = this.handlePageClick.bind(this);
    this.isComponentMounted = false
  }

   // Lifecycle method: Called after the component mounts
   componentDidMount() {
    this.postCategoryIdValue();
  }

  // Fetches category ID for "ADVISORY"
  postCategoryIdValue() {
    this.isComponentMounted = true;
    fetch(
      `${window.appConfig.getContentCategories}${window.appConfig.Relam}${window.appConfig.Relam}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (!this.isComponentMounted) return; // Ensure the component is still mounted
  
        // Filter categories to find "ADVISORY"
        const postid = result.categoryList.filter(
          (data) => data.categoryname === "ADVISORY"
        );
  
        if (postid.length === 0) {
          console.warn("No matching category found");
          return;
        }
  
        const categoryId = postid[0].categoryid;
  
        // Call functions using the retrieved categoryId
        this.viewAllAdvisary(categoryId);
        this.setState({
          postCategoryIdValue: categoryId, // Fixed typo
        });
        this.adminsDropdownClick(categoryId);
        this.getCategorySubcategories(categoryId);
        this.ownerDropdownClick(categoryId);
      })
      .catch((err) => console.log("Fetch error:", err));
  }

  // Lifecycle method: Called before the component unmounts
  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  // Fetches all advisories for a given category ID
  viewAllAdvisary(postid) {
    fetch(
      `${window.appConfig.getContentList}${window.appConfig.Relam}category/${postid}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          copyOfTenders: result.contentList,
          tensdersPageCount: Math.ceil(
            result.contentList.length / this.state.perPage
          ),
        });
      });
  }

  // Fetches content creators (admins) for a given category ID
  adminsDropdownClick(catID) {
    fetch(
      `${window.appConfig.getContentCreator}${window.appConfig.Relam}contentcreators/${catID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        // Remove duplicate content creators
        const unique = [
          ...new Map(
            result.contentcreatorsList.map((data) => [data.contentcreatorid, data])
          ).values(),
        ];
        this.setState({
          tendersFilter: unique,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // Toggles the visibility of the organizations dropdown
  organizationsDropdownClick() {
    $("#dropdownAdvisory").toggle();
  }

  // Fetches advisory content based on selected content creator
  organizationsOnClick(Creator) {
    fetch(
      `${window.appConfig.getContentonContentCreator}${window.appConfig.Relam}contentcreator/${Creator}/${this.state.postCategoryIdVlaue}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          tensdersPageCount: Math.ceil(
            result.contentList.length / this.state.perPage
          ),
        });
      })
      .catch((err) => console.log("err", err));
    
    // Hide dropdown after selection
    $("#dropdownAdvisory").hide();
  }

  // Fetches subcategories for a given category ID
  getCategorySubcategories(catID) {
    if (!catID) return;
    fetch(`${window.appConfig.getContentSubcategories}${window.appConfig.Relam}${window.appConfig.Relam}${window.appConfig.Relam}${catID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())    
      .then((result) => {
        this.setState({
          subCategoriesList: result.contentsubcategories,
        });
      })
      .catch((err) => console.log("err", err));
  }

  // Toggles the subcategories dropdown
  subCategoriesDropdownClick() {
    $("#subCategoriesOfAdvisory").toggle();
  }

  // Filters content based on selected subcategory
  subCategoriesOnClick(subCategory) {
    const subCategoriesOfAdsFilter = this.state.copyOfTenders.filter((data) => {
      return data.contentsubcategory
        .toLowerCase()
        .includes(subCategory.toLowerCase());
    });

    this.setState({
      tenders: subCategoriesOfAdsFilter,
      tensdersPageCount: Math.ceil(
        subCategoriesOfAdsFilter.length / this.state.perPage
      ),
    });

    // Hide dropdown after selection
    $("#subCategoriesOfAdvisory").hide();
  }

  // Increases the like count for a content item
  likeCount(contentid) {
    fetch(
      `${window.appConfig.contentLikeCount}${window.appConfig.Relam}${contentid}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.text())
      .then((result) => {
        this.postCategoryIdValue();
        return NotificationManager.success(result);
      })
      .catch((err) => console.log("err", err));
  }

  // Fetches content owners for a given category ID
  ownerDropdownClick(catID) {
    fetch(
      `${window.appConfig.getAllContentOwnersBasedOnCategory}${catID}`, 
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        // Remove duplicate content owners
        const unique = [
          ...new Map(
            result.contentownerList.map((data) => [data.contentowner, data])
          ).values(),
        ];
        this.setState({
          contentOwners: unique,
        });
      })
      .catch((err) => console.log("err", err));
  }

  // Toggles content owner dropdown
  contentOwnerDropdownClick() {
    $("#ContentOwnerOfAdvisory").toggle();
  }

  // Fetches content based on selected content owner
  getContentOwnerContent(Owner) {
    fetch(
      `${window.appConfig.getContentList}${window.appConfig.Relam}contentowner/${Owner}/${this.state.postCategoryIdVlaue}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          tensdersPageCount: Math.ceil(
            result.contentList.length / this.state.perPage
          ),
        });
      })
      .catch((err) => console.log("err", err));

    // Hide dropdown after selection
    $("#dropdownAdvisory").hide();
  }

  /* Pagination */
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
      },
      () => {}
    );
  };
  /* End of Pagination */

  render() {
    // Destructuring state variables for easier access
    const { tenders, subCategoriesList, contentOwners } = this.state;
    
    // Slicing the tenders list based on pagination offset and perPage count
    const tendersList = tenders.slice(
      this.state.offset,
      this.state.offset + this.state.perPage
    );
  
    return (
      <Container
        id="tendersContainer"
        className="gbr-engage-container container-fluid mb-lg-5 mb-4 mt-4"
      >
        <div className="mb-4">
          {/* Expert Advice Button */}
          <div className="dropdown ">
            <div className="navbarRight">
              <button
                className="btn btn-success homepageBtn"
                type="button"
                onClick={() =>
                  this.viewAllAdvisary(this.state.postCategoryIdVlaue)
                }
              >
                Expert Advice
              </button>
            </div>
          </div>
  
          {/* Publisher Dropdown */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.organizationsDropdownClick()}
                >
                  Publisher
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="dropdownAdvisory"
                aria-labelledby="dropdownAdvisory"
              >
                {this.state.tendersFilter &&
                  this.state.tendersFilter.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.organizationsOnClick(filter.contentcreatorid)
                        }
                      >
                        {filter.contentcreatorid}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>
  
          {/* Sub Categories Dropdown */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.subCategoriesDropdownClick()}
                >
                  Sub Categories
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="subCategoriesOfAdvisory"
                aria-labelledby="subCategoriesOfAdvisory"
              >
                {subCategoriesList &&
                  subCategoriesList.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.subCategoriesOnClick(filter.contentsubcategoryname)
                        }
                      >
                        {filter.contentsubcategoryname}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>
  
          {/* Asset Type / Modal Dropdown */}
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.contentOwnerDropdownClick()}
                >
                  Asset type / Modal
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="ContentOwnerOfAdvisory"
                aria-labelledby="ContentOwnerOfAdvisory"
              >
                {contentOwners &&
                  contentOwners.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.getContentOwnerContent(filter.contentowner)
                        }
                      >
                        {filter.contentowner}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>
        </div>
  
        {/* Display Advice */}
        <div className="adminTendersDiv">
          {tendersList.length !== 0 ? (
            <Row className="justify-content-center">
              {tendersList.map((tend, index) => (
                <Col md={6} lg={4} sm={12} xs={12} className="mb-4" key={index}>
                  <div className="community-cards w-100">
                    <div className="bordered-div"></div>
                    <div className="pb-2">
                      <div className="scrollable-container scrollable-container-mod">
                        <div className="community-card-body">
                          <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                            <span className=" d-block ">
                              {tend.contentsubcategory}
                            </span>
                            <p className="products-like mb-0 d-flex align-items-end">
                              <span
                                className="d-inline-block"
                                onClick={() => {
                                  this.likeCount(tend.contentid);
                                }}
                              >
                                <FiThumbsUp size={30} />
                              </span>
                              <small>{tend.likecount}</small>
                            </p>
                          </div>
  
                          {/* Content Details */}
                          <h2 className="mb-0">{tend.contentname}</h2>
  
                          <h5 className="mb-2">
                            Posted by <span>{tend.contentcreatorid}</span>,{" "}
                            {tend.timestamp}
                          </h5>
                          <a className="text-decoration-none" href={tend.texturl} target="_blank">
                            <h6 className="mb-3">{tend.contentdescription}</h6>
                          </a> 
                          <img
                            className="img-thumbnail "
                            src={tend.locationurl}
                            width="100%"
                            height="250"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
  
              {/* Pagination Component */}
              <div className="paginationComponent">
                <ReactPaginate
                  previousLabel={"<<"}
                  nextLabel={">>"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.tensdersPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </Row>
          ) : (
            <div className="card">
              <p className="card-body container-heading2">
                <b>Advisory's Not Found</b>
              </p>
            </div>
          )}
        </div>
  
        {/* Outside Click Handler for Dropdowns */}
        <OutsideClickHandler
          onOutsideClick={() => {
            $("#dropdownAdvisory").hide();
            $("#subCategoriesOfAdvisory").hide();
            $("#ContentOwnerOfAdvisory").hide();
          }}
        >
          <></>
        </OutsideClickHandler>
      </Container>
    );
  }
  
}

export default AdvisaryComponent;
